import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Client,
  CreateClientRequest,
  UpdateClientRequest,
  ClientsListParams,
  ClientMetrics
} from '../types';

const { CLIENTS } = API_ENDPOINTS;

export const clientsApi = {
  getAll: (params?: ClientsListParams) =>
    apiClient.getPaginated<Client>(CLIENTS.LIST, params),

  getById: (id: number) => apiClient.get<Client>(CLIENTS.GET(id)),

  create: (data: CreateClientRequest, onProgress?: (n: number) => void) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('admin_email', data.admin_email);
    formData.append('password', data.password);
    if (data.notes) {
      formData.append('notes', data.notes);
    }
    if (data.logo) {
      formData.append('logo', data.logo);
    }
    return apiClient.uploadFormData<Client>(
      CLIENTS.CREATE,
      formData,
      onProgress
    );
  },

  update: (
    id: number,
    data: UpdateClientRequest,
    onProgress?: (n: number) => void
  ) => {
    const formData = new FormData();
    formData.append('_method', 'PUT');
    if (data.name !== undefined) {
      formData.append('name', data.name);
    }
    if (data.admin_email !== undefined) {
      formData.append('admin_email', data.admin_email);
    }
    if (data.password) {
      formData.append('password', data.password);
    }
    if (data.notes !== undefined) {
      formData.append('notes', data.notes ?? '');
    }
    if (data.logo) {
      formData.append('logo', data.logo);
    }
    return apiClient.uploadFormData<Client>(
      CLIENTS.UPDATE(id),
      formData,
      onProgress
    );
  },

  delete: (id: number) => apiClient.delete(CLIENTS.DELETE(id)),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<ClientsListParams> }
  ) => apiClient.post(CLIENTS.BULK_DELETE, params),

  metrics: () => apiClient.get<ClientMetrics>(CLIENTS.METRICS)
};
